if (!customElements.get('mega-menu-collection')) {
  class MegaMenuCollection extends HTMLElement {
    constructor() {
      super();
      this.tabMenu = Array.from(this.querySelectorAll('[tab-menu]'));
      this.tabContent = Array.from(this.querySelectorAll('[tab-content]'));
      this._hoverTimer = null;
      this.swiperIntiate();
    }

    connectedCallback() {
      if (!this.tabMenu.length) return;
      // CUSTOM(fix/megamenu-collection-link): 侧栏每一条本来就是指向集合页的 <a href>,
      // 但原版在 click 上无条件 preventDefault 来切换右侧预览, 等于吞掉了 href ——
      // 点击集合名什么都不会发生。改成 hover / 键盘 focus 切预览, click 走原生跳转
      // (header 本身就是 open_menu_items_on: hover, 交互模型一致)。
      this.tabMenu.forEach((tab, index) => {
        tab.addEventListener('pointerenter', (e) => {
          // 触屏没有"悬停"这一步: 一次点按就是要跳转, 不必抢跑懒加载
          if (e.pointerType === 'touch') return;
          this._scheduleTab(index);
        });
        tab.addEventListener('pointerleave', () => this._cancelScheduledTab());
        tab.addEventListener('focus', (e) => {
          // 只响应键盘 focus; 鼠标点击带来的 focus 由 pointerenter 分支负责
          if (e.target.matches && !e.target.matches(':focus-visible')) return;
          this._activateTab(index);
        });
        // 刻意不 preventDefault: 让浏览器正常跳转到 collection.url
        tab.addEventListener('click', () => this._cancelScheduledTab());
      });
    }

    disconnectedCallback() {
      this._cancelScheduledTab();
    }

    // hover intent: 指针斜穿列表时不要逐项切 tab, 也不要逐项打懒加载请求
    _scheduleTab(activeIndex) {
      this._cancelScheduledTab();
      this._hoverTimer = setTimeout(() => {
        this._hoverTimer = null;
        this._activateTab(activeIndex);
      }, 100);
    }

    _cancelScheduledTab() {
      if (this._hoverTimer === null) return;
      clearTimeout(this._hoverTimer);
      this._hoverTimer = null;
    }

    _activateTab(activeIndex) {
      this.tabMenu.forEach((tab, idx) => {
        tab.classList.toggle('active', idx === activeIndex);
      });
      this.tabContent.forEach((content, idx) => {
        content.classList.toggle('active', idx === activeIndex);
      });
      const active = this.tabContent[activeIndex];
      if (active && active.hasAttribute('data-lazy') && active.dataset.loaded !== 'true') {
        this._loadTab(active);
      }
    }

    _loadTab(content) {
      if (content.dataset.loaded === 'true' || content.dataset.loading === 'true') return;
      const handle = content.dataset.collectionHandle;
      if (!handle) return;
      content.dataset.loading = 'true';
      content.classList.add('is-loading');
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const url = `${root}collections/${handle}?section_id=mega-menu-collection-products`;
      fetch(url)
        .then((r) => {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const slides = doc.querySelector('[data-mega-slides]');
          const wrapper = content.querySelector('.swiper-wrapper');
          if (!slides || !wrapper) return;
          wrapper.innerHTML = slides.innerHTML;
          content.dataset.loaded = 'true';
          const swiperProperty = content.dataset.swiper;
          if (swiperProperty && !content.classList.contains('swiper')) {
            content.classList.add('swiper');
            try {
              theme.SwiperSliderInit(content, JSON.parse(swiperProperty));
            } catch (e) {
              /* swiper init is best-effort; slides are still visible without it */
            }
          }
        })
        .catch(() => {
          // On failure the sidebar tab link still points to the collection page.
          content.classList.add('is-error');
        })
        .finally(() => {
          content.dataset.loading = 'false';
          content.classList.remove('is-loading');
        });
    }
      swiperIntiate() {
      this.tabContent.forEach((swiper) => {
        const swiperProperty = swiper.dataset.swiper;
          if (!swiperProperty) return;
        const properties = JSON.parse(swiperProperty);
          if(swiper.classList.contains('swiper')){
              theme.SwiperSliderInit(swiper,properties );
          }
      });
    
    } 
  }
  customElements.define('mega-menu-collection', MegaMenuCollection);
}